/*!

=========================================================
* Light Bootstrap Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  Table,
  Pagination,
  FormControl,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import {
  getMedicationcategory,
  deletecategory,
  getMedicationcategorysearch,
  getMedicationwt_commsearch,
  getMedicationbothsearch,
} from "../../../Listfunction";
// react component that creates a switch button that changes from on to off mode
import { Link, withRouter } from "react-router-dom";

import Switch from "react-bootstrap-switch";

import Card from "components/Card/Card.jsx";
import SweetAlert from "react-bootstrap-sweetalert";

import Button from "components/CustomButton/CustomButton.jsx";
import ReactTable from "react-table";
import LoadingSpinner from "views/Components/loadingSpinner";
import NotificationSystem from "react-notification-system";
import { style } from "../../../variables/Variables";
import { getApiErrorMessage } from "utils/getApiErrorMessage";

class viewmedicationcategory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      catogory_detail: [],
      search_wt_commision: "",
      search_category: "",
      paginationData: [],
      nextpage: "",
      prevpage: "",
      currentPage: 1,
      nextdisabled: "1",
      prevdisabled: "1",
      tabledata: "",
      loading: false,
      _notificationSystem: null,
      cardHidden: true,
      alert: null,
      is_featured: "",
      useraccess: "",
      _notificationSystem: null,
      noRecordFound: false,
    };
    this.onChange = this.onChange.bind(this);
    this.searchCategory = this.searchCategory.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.resetSearch = this.resetSearch.bind(this);
    this.getdata = this.getdata.bind(this);
    this.selectedcategory = this.selectedcategory.bind(this);
    this.deletemedicatoncategory = this.deletemedicatoncategory.bind(this);
    this.warningWithConfirmAndCancelMessage =
      this.warningWithConfirmAndCancelMessage.bind(this);
  }
  resetSearch(e) {
    this.setState({
      is_featured: "",
    });
    this.setState({
      search_category: "",
    });
    this.setState({
      search_wt_commision: "",
    });
    setTimeout(
      function () {
        this.searchCategory();
      }.bind(this),
      700,
    );
  }
  selectedcategory(cus) {
    // console.log(cus);
    localStorage.setItem("cat_id", JSON.stringify(cus));
    this.props.history.push("/admin/edit_medication_category");
  }
  searchCategory = (e) => {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    var category = this.state.search_category;
    var wt_commi = this.state.search_wt_commision;

    let serach_string = "";
    if (category == "") {
      serach_string = serach_string + "";
    } else {
      serach_string = serach_string + "category_name=" + category;
    }
    if (wt_commi == "") {
      serach_string = serach_string + "";
    } else {
      if (serach_string == "") {
        serach_string = serach_string + "wt_commision=" + wt_commi;
      } else {
        serach_string = serach_string + "&wt_commision=" + wt_commi;
      }
    }
    this.getdata(
      process.env.REACT_APP_NOT_SECRET_CODE +
        "/medicationCategories?" +
        serach_string +
        "&is_featured=" +
        this.state.is_featured,
    );
  };
  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  handleSuccess(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Medication Category</b> - Deleted Successfully .
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  handleClick(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Something went wrong</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  warningWithConfirmAndCancelMessage(id) {
    // alert('hi');
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Are you sure?"
          onConfirm={() => this.deletemedicatoncategory(id)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="Yes, delete it!"
          cancelBtnText="Cancel"
          showCancel
        >
          You will not be able to recover this Category !
        </SweetAlert>
      ),
    });
  }
  hideAlert() {
    this.setState({
      alert: null,
    });
  }
  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
    var token = JSON.parse(localStorage.getItem("user"));
    // console.log(token.token);
    const obj = token.token;
    this.setState({
      useraccess: token.role,
    });
    this.setState({ _notificationSystem: this.refs.notificationSystem });
    setTimeout(
      function () {
        this.setState({ cardHidden: false });
      }.bind(this),
      700,
    );

    this.getdata(
      process.env.REACT_APP_NOT_SECRET_CODE + "/medicationCategories",
    );
  }
  handleNetworkError(position, error) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          {/* <b>Network Error</b>. */}
          <b>{getApiErrorMessage(error)}</b>
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  getdata(url) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.setState({ noRecordFound: false });

    this.setState({ loading: true }, () => {
      fetch(url, {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      })
        .then((response) => response.json())
        .then((response1) => {
          var cat_data = response1.data;
          var data = response1.data;

          if (data.data.length == 0) {
            this.setState({ noRecordFound: true });
          }
          var $no_pages = [];
          let serach_url = "";
          var category = this.state.search_category;
          var wt_commi = this.state.search_wt_commision;
          let serach_string = "";
          if (category == "") {
            serach_string = serach_string + "";
          } else {
            serach_string = serach_string + "category_name=" + category;
          }
          if (wt_commi == "") {
            serach_string = serach_string + "";
          } else {
            if (serach_string == "") {
              serach_string = serach_string + "wt_commision=" + wt_commi;
            } else {
              serach_string = serach_string + "&wt_commision=" + wt_commi;
            }
          }
          if (serach_string == "") {
            serach_url =
              process.env.REACT_APP_NOT_SECRET_CODE + "/medicationCategories";
          } else {
            serach_url =
              process.env.REACT_APP_NOT_SECRET_CODE +
              "/medicationCategories?" +
              serach_string;
          }

          for (var i = 1; i <= data.last_page; i++) {
            if (serach_string == "") {
              $no_pages.push(serach_url + "?page=" + i);
            } else {
              $no_pages.push(serach_url + "&page=" + i);
            }
          }

          if (data.current_page == data.last_page) {
            this.setState({ prevdisabled: null });
            this.setState({ nextdisabled: "1" });
          } else if (data.current_page == 1) {
            this.setState({ nextdisabled: null });
            this.setState({ prevdisabled: "1" });
          } else {
            this.setState({ nextdisabled: null });
            this.setState({ prevdisabled: null });
          }
          if (data.last_page == 1) {
            this.setState({ nextdisabled: 1 });
            this.setState({ prevdisabled: 1 });
          }
          if (data.data.length == 0) {
            $no_pages = [];
            this.setState({ nextdisabled: 1 });
            this.setState({ prevdisabled: 1 });
          }
          this.setState({ currentPage: data.current_page });
          if (data.next_page_url != null) {
            if (serach_string == "") {
              this.setState({
                nextpage:
                  serach_url +
                  "?page=" +
                  data.next_page_url.substring(
                    data.next_page_url.indexOf("=") + 1,
                  ),
              });
            } else {
              this.setState({
                nextpage:
                  serach_url +
                  "&page=" +
                  data.next_page_url.substring(
                    data.next_page_url.indexOf("=") + 1,
                  ),
              });
            }
          } else {
            this.setState({ nextpage: "#" });
          }
          if (data.prev_page_url != null) {
            if (serach_string == "") {
              this.setState({
                prevpage:
                  serach_url +
                  "?page=" +
                  data.prev_page_url.substring(
                    data.prev_page_url.indexOf("=") + 1,
                  ),
              });
            } else {
              this.setState({
                prevpage:
                  serach_url +
                  "&page=" +
                  data.prev_page_url.substring(
                    data.prev_page_url.indexOf("=") + 1,
                  ),
              });
            }
          } else {
            this.setState({ prevpage: "#" });
          }
          this.setState({ paginationData: $no_pages });
          const tabledata = cat_data.data.map((cus) => {
            const edit = <Tooltip id="edit">Edit </Tooltip>;
            const remove = <Tooltip id="remove">Remove</Tooltip>;
            return (
              <tr>
                <td>{cus.category_name}</td>
                <td>{cus.wt_commision}</td>
                <td>{cus.is_featured == "0" ? "No" : "Yes"}</td>
                <td className="td-actions text-right">
                  <OverlayTrigger placement="top" overlay={edit}>
                    <Button
                      simple
                      bsStyle="success"
                      onClick={this.selectedcategory.bind(this, cus.id)}
                      bsSize="xs"
                    >
                      <Link to="/admin/edit_medication_category">
                        <i className="fa fa-edit" />
                      </Link>
                    </Button>
                  </OverlayTrigger>
                  {this.state.useraccess == 1 && (
                    <OverlayTrigger placement="top" overlay={remove}>
                      <Button
                        simple
                        bsStyle="danger"
                        onClick={this.warningWithConfirmAndCancelMessage.bind(
                          this,
                          cus.id,
                        )}
                        bsSize="xs"
                      >
                        <i className="fa fa-times" />
                      </Button>
                    </OverlayTrigger>
                  )}
                </td>
              </tr>
            );
          });
          this.setState({
            loading: false,
            tabledata: tabledata,
          });
        })
        .catch((error) => {
          console.log(error, "== error");
          this.handleNetworkError("bl", error);
        });
    });
  }
  deletemedicatoncategory(id) {
    var token = JSON.parse(localStorage.getItem("user"));
    // console.log(token.token);
    const obj = token.token;
    deletecategory(id, obj)
      .then((res) => {
        if (res.data.success === false) {
          this.handleClick("bl");
        } else if (res.data.success === true) {
          this.handleSuccess("bl");
          window.location.reload(true);

          // this.props.history.push('/admin/medication-category');

          // this.setState({
          //   medicationcategoryname : '',
          //   wt_commision : ''
          // })
        }
        // alert('category deleted');
        // window.location.href="#/admin/medication-category";
      })
      .catch((error) => {
        console.log(error, "== error");
        this.handleNetworkError("bl", error);
      });
  }
  addcategory() {
    this.props.history.push("/admin/add_medication_category");
  }
  render() {
    // const view = <Tooltip id="view">View Profile</Tooltip>;
    const edit = <Tooltip id="edit">Edit </Tooltip>;
    const remove = <Tooltip id="remove">Remove</Tooltip>;

    var c = 1;

    return (
      <div className="main-content">
        <Grid fluid>
          {this.state.alert}
          <NotificationSystem ref="notificationSystem" style={style} />

          <Row>
            <Col md={12}>
              <Card
                tableFullWidth
                content={
                  <Row>
                    <Row>
                      <Col md={12}>
                        <Button
                          style={{ float: "right", "margin-right": "20px" }}
                          class="btn-color" //bsStyle="info"
                          fill
                          onClick={this.addcategory.bind(this)}
                        >
                          Add Medication Category <i className="fa fa-plus"></i>
                        </Button>
                      </Col>
                    </Row>
                    <br></br>
                    <div
                      style={{
                        paddingBottom: "8%",
                        width: "71%",
                        paddingRight: "-15px",
                        paddingTop: "1%",
                        marginLeft: "9%",
                        paddingBottom: "6%",
                        borderStyle: "dashed",
                        borderColor: "#A9A9A9",
                        borderWidth: "2px",
                        borderRadius: "12px",
                        marginRight: "10%",
                      }}
                    >
                      <Col md={3} style={{ "margin-left": "1px" }}>
                        <FormControl
                          name="search_category"
                          value={this.state.search_category || ""}
                          placeholder="Medication Category"
                          onChange={this.onChange}
                          type="text"
                        />
                      </Col>
                      <Col md={3} style={{ "margin-left": "20px" }}>
                        <FormControl
                          name="search_wt_commision"
                          value={this.state.search_wt_commision || ""}
                          placeholder="Wt-Commision"
                          onChange={this.onChange}
                          type="text"
                        />
                      </Col>
                      <Col
                        md={1}
                        sm={1}
                        lg={1}
                        xs={12}
                        className="fl_mb_1 w_150"
                        style={{ width: "15%", marginTop: "5px" }}
                      >
                        {/* <FormControl  name="commision" value={this.state.commision ||''} placeholder="Commision" onChange={this.onChange} type="text" /> */}
                        <select
                          name="is_featured"
                          placeholder="is_featured"
                          value={this.state.is_featured || ""}
                          onChange={this.onChange}
                          className="form-control"
                        >
                          <option value="">Is Featured</option>
                          <option value="1">Yes</option>
                          <option value="0">No</option>
                        </select>
                      </Col>

                      <Col md={3} sm={4} lg={3} xs={12} className="fl_mb_1">
                        <Button
                          class="btn-color" //bsStyle="info"
                          fill
                          onClick={this.searchCategory.bind(this)}
                        >
                          Filter
                        </Button>
                        &nbsp;&nbsp;
                        <Button
                          class="btn-color" //bsStyle="info"
                          fill
                          onClick={this.resetSearch.bind(this)}
                        >
                          Reset
                        </Button>
                      </Col>
                    </div>

                    <Col md={12}>
                      <Table responsive>
                        <thead>
                          <tr>
                            <th> Medication Category Name</th>
                            <th>WT_Commision</th>
                            <th>Feature</th>
                            <th className="text-right">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.loading ? (
                            <tr>
                              <td colspan="10">
                                <LoadingSpinner />
                              </td>
                            </tr>
                          ) : this.state.noRecordFound ? (
                            <tr>
                              <td colspan="10">
                                <center>No record found</center>
                              </td>
                            </tr>
                          ) : (
                            <React.Fragment>
                              {this.state.tabledata}
                            </React.Fragment>
                          )}
                          {/* {category.map( (cus) => (                      
                      <tr>
                        
                        <td>{cus.category_name}</td>
                        <td>{cus.wt_commision}</td>
                        <td className="td-actions text-right">
        <OverlayTrigger placement="top" overlay={edit}>
          <Button simple bsStyle="success" onClick={this.selectedcategory.bind(this,cus.id)}  bsSize="xs">
          <Link to='/admin/edit_medication_category' >
            <i className="fa fa-edit" />
            </Link>
          </Button>
        </OverlayTrigger>
        <OverlayTrigger placement="top" overlay={remove}>
          <Button simple bsStyle="danger" onClick={this.deletemedicatoncategory.bind(this,cus.id)}  bsSize="xs">
            <i className="fa fa-times" />
          </Button>
        </OverlayTrigger>
      </td>
                      
                      </tr>
                        ))} */}
                        </tbody>
                      </Table>
                      {this.state.loading ? (
                        ""
                      ) : this.state.noRecordFound ? (
                        ""
                      ) : (
                        <div style={{ textAlign: "center" }}>
                          <Pagination>
                            <Pagination.First
                              dataUrl={this.state.prevpage}
                              onClick={this.getdata.bind(
                                this,
                                this.state.prevpage,
                              )}
                              disabled={this.state.prevdisabled}
                            />
                            {this.state.paginationData.map((url) => (
                              <Pagination.Item
                                dataUrl={url}
                                active={
                                  this.state.currentPage == c ? "1" : null
                                }
                                onClick={this.getdata.bind(this, url)}
                              >
                                {c++}
                              </Pagination.Item>
                            ))}
                            <Pagination.Last
                              dataUrl={this.state.nextpage}
                              onClick={this.getdata.bind(
                                this,
                                this.state.nextpage,
                              )}
                              disabled={this.state.nextdisabled}
                            />
                          </Pagination>
                        </div>
                      )}
                    </Col>
                  </Row>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default withRouter(viewmedicationcategory);
